/* BENEATH — buy box + AJAX cart drawer + size finder + sticky bar. No dependencies. */
(function () {
  'use strict';

  /* ===== In-app browser (Facebook/Instagram WebView) compatibility shims =====
     97% of traffic is the FB/IG in-app browser; older Android WebViews lack these,
     which throws and silently breaks the buy box / add-to-cart. */
  if (typeof NodeList !== 'undefined' && NodeList.prototype && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
  }
  if (typeof Promise !== 'undefined' && Promise.prototype && !Promise.prototype.finally) {
    Promise.prototype.finally = function (cb) {
      return this.then(
        function (v) { return Promise.resolve(typeof cb === 'function' ? cb() : cb).then(function () { return v; }); },
        function (e) { return Promise.resolve(typeof cb === 'function' ? cb() : cb).then(function () { throw e; }); }
      );
    };
  }

  var AR = (typeof window !== 'undefined' && window.BENEATH_AR === true);

  var moneyFormat = '{{amount}}';

  function money(amount) {
    var str = (amount / 100).toLocaleString('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: (amount % 100 === 0) ? 0 : 2
    });
    return moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, str);
  }

  /* ============ BUY BOX ============ */
  var box = document.querySelector('[data-buybox]');
  if (!box) return;

  var data;
  try { data = JSON.parse(box.querySelector('[data-variants]').textContent); } catch (e) { return; }
  moneyFormat = data.moneyFormat || moneyFormat;
  var cartApi = window.BeneathCart;
  var sockToggle = box.querySelector("[data-socks-toggle]");
  function socksCount() {
    return sockToggle && sockToggle.checked && cartApi && cartApi.config.socksAvailable
      ? cartApi.socksQuantity(sockToggle.closest('[data-socks-offer]')) : 0;
  }
  var buying = false;

  var state = { color: null, size: null, pack: null };
  var packBtns = box.querySelectorAll('.pack');
  var colorBtns = box.querySelectorAll('.color-opt');
  var sizeBtns = box.querySelectorAll('.size-opt');
  var cta = box.querySelector('[data-buy-cta]');
  var counter = box.querySelector('[data-tap-counter]');
  var heroImg = document.querySelector('[data-hero-img]');
  var thumbsWrap = document.querySelector('[data-thumbs]');
  var stickyBar = document.querySelector('.sticky-buy');
  var stickyCta = stickyBar ? stickyBar.querySelector('[data-sticky-cta]') : null;
  var stickyPrice = stickyBar ? stickyBar.querySelector('.price') : null;

  packBtns.forEach(function (b) { if (b.getAttribute('aria-pressed') === 'true') state.pack = packFrom(b); });
  colorBtns.forEach(function (b) { if (b.getAttribute('aria-pressed') === 'true') state.color = b.dataset.color; });

  function packFrom(btn) { return { qty: parseInt(btn.dataset.qty, 10), discount: parseFloat(btn.dataset.discount) || 0 }; }
  function findVariant() {
    if (!state.color || !state.size) return null;
    return data.variants.find(function (v) { return v.color === state.color && v.size === state.size; }) || null;
  }
  function colorSoldOut(color) { return !data.variants.some(function (v) { return v.color === color && v.available; }); }
  function allSoldOut() { return !data.variants.some(function (v) { return v.available; }); }

  function renderGallery() {
    if (!thumbsWrap || !data.galleries) return;
    var imgs = data.galleries[state.color] || [];
    var thumbSrcs = (data.thumbs && data.thumbs[state.color]) || imgs;
    thumbsWrap.innerHTML = '';
    imgs.forEach(function (src, i) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'thumb';
      b.setAttribute('aria-label', 'Photo ' + (i + 1));
      b.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');
      var im = document.createElement('img');
      im.src = thumbSrcs[i] || src; im.alt = ''; im.loading = 'lazy'; im.width = 160; im.height = 160;
      b.appendChild(im);
      b.addEventListener('click', function () {
        heroImg.removeAttribute("srcset"); heroImg.src = src; heroImg.alt = heroAlt(i);
        thumbsWrap.querySelectorAll('.thumb').forEach(function (t) { t.setAttribute('aria-pressed', t === b ? 'true' : 'false'); });
      });
      thumbsWrap.appendChild(b);
    });
    if (imgs[0] && heroImg) { heroImg.removeAttribute("srcset"); heroImg.src = imgs[0]; heroImg.alt = heroAlt(0); }
  }
  function heroAlt(i) {
    var base = (heroImg && heroImg.alt ? heroImg.alt.split(' — ')[0] : 'Product');
    return base + ' — ' + state.color + ', photo ' + (i + 1);
  }

  function refreshSizes() {
    sizeBtns.forEach(function (b) {
      var v = data.variants.find(function (x) { return x.color === state.color && x.size === b.dataset.size; });
      var out = !v || !v.available;
      b.disabled = out;
      b.setAttribute('aria-disabled', out ? 'true' : 'false');
      if (out && b.getAttribute('aria-pressed') === 'true') {
        b.setAttribute('aria-pressed', 'false');
        if (state.size === b.dataset.size) state.size = null;
      }
    });
    colorBtns.forEach(function (b) { b.classList.toggle('soldout', colorSoldOut(b.dataset.color)); });
    var notifyEl = box.querySelector('[data-size-notify]');
    if (notifyEl) {
      var anyOut = Array.prototype.some.call(sizeBtns, function (b) { return b.disabled; });
      notifyEl.hidden = !anyOut;
      if (data.notifyUrl) notifyEl.setAttribute('href', data.notifyUrl);
    }
  }

  function render() {
    var soldout = allSoldOut() || colorSoldOut(state.color);
    var v = findVariant();
    var pack = state.pack || { qty: 1, discount: 0 };
    var ready = !soldout && !!v && v.available;

    if (soldout) {
      cta.setAttribute('aria-disabled', 'true');
      cta.classList.add('disabled');
      cta.textContent = data.soldoutLabel || 'Sold out';
      cta.removeAttribute('data-variant');
      if (counter) counter.innerHTML = AR ? 'الكمية خلصت. اللي بعدها مش هتستنّاك.' : 'this drop is gone. the next one won’t wait.';
      if (stickyBar) stickyBar.classList.remove('visible');
      return;
    }

    if (ready) {
      var total = v.price * pack.qty * (1 - pack.discount / 100); // price is major units from Liquid divided_by 100
      var totalCents = Math.round(total * 100);
      if (socksCount()) totalCents += cartApi.socksTotal(socksCount());
      cta.classList.remove('disabled');
      cta.dataset.variant = v.id;
      cta.dataset.qty = pack.qty;
      cta.textContent = (cta.dataset.labelReady || 'Add QTY — TOTAL').replace('QTY', pack.qty).replace('TOTAL', money(totalCents));
      if (socksCount()) cta.textContent = 'Add boxers + ' + socksCount() * 3 + ' pairs of socks — ' + money(totalCents);
      if (stickyCta) { stickyCta.textContent = 'Add to bag — ' + money(totalCents); stickyCta.classList.remove('disabled'); }
      if (stickyPrice) stickyPrice.textContent = money(totalCents);
    } else {
      cta.classList.add('disabled');
      cta.removeAttribute('data-variant');
      cta.textContent = cta.dataset.labelWaiting || 'Pick your size';
      if (stickyCta) { stickyCta.textContent = cta.dataset.labelWaiting || 'Pick your size'; stickyCta.classList.add('disabled'); }
      /* still show the pack total before a size is picked, so the sticky bar always
         communicates the offer (price) even to visitors who never scroll. */
      if (stickyPrice) {
        var any = data.variants[0];
        if (any) {
          var t = any.price * pack.qty * (1 - pack.discount / 100);
          stickyPrice.textContent = money(Math.round(t * 100) + (socksCount() ? cartApi.socksTotal(socksCount()) : 0));
        }
      }
    }
    cta.setAttribute('aria-disabled', ready ? 'false' : 'true');
    var shipping = box.querySelector('[data-product-shipping]');
    if (shipping) {
      var priceVariant = v || data.variants[0];
      var selectionTotal = priceVariant ? Math.round(priceVariant.price * 100 * pack.qty * (1 - pack.discount / 100)) : 0;
      if (socksCount()) selectionTotal += cartApi.socksTotal(socksCount());
      shipping.textContent = selectionTotal >= (cartApi ? cartApi.config.shippingThreshold : 80000)
        ? 'Free shipping included · Cash on delivery' : 'Delivery EGP 60 · Free shipping from EGP 800';
    }
    if (counter) counter.innerHTML = ready ? (AR ? 'اختار الباك وكمل الطلب.' : 'choose your pack, then checkout.') : (AR ? 'اختار مقاسك.' : 'pick your size.');
  }

  function press(group, btn) { group.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); }); }

  packBtns.forEach(function (b) { b.addEventListener('click', function () { press(packBtns, b); state.pack = packFrom(b); render(); }); });
  colorBtns.forEach(function (b) { b.addEventListener('click', function () { press(colorBtns, b); state.color = b.dataset.color; renderGallery(); refreshSizes(); render(); }); });
  sizeBtns.forEach(function (b) { b.addEventListener('click', function () { if (b.disabled) return; press(sizeBtns, b); state.size = b.dataset.size; render(); }); });

  function doBuy() {
    var v = findVariant();
    if (buying || !v || !v.available || !cartApi) return;
    var pack = state.pack || { qty: 1 };
    var items = [{ id: v.id, quantity: pack.qty }];
    if (sockToggle && sockToggle.checked && cartApi.config.socksAvailable) {
      items.push({ id: cartApi.config.socksVariant, quantity: socksCount() });
    }
    buying = true;
    cta.classList.add('loading');
    cta.setAttribute('aria-busy', 'true');
    cartApi.add(items).catch(function () {
      // Error is shown beside the buy button. Never replace an existing cart.
    }).finally(function () {
      buying = false; cta.classList.remove('loading'); cta.removeAttribute('aria-busy'); render();
    });
  }
  function chooseSize() {
    var target = Array.from(sizeBtns).find(function (button) { return !button.disabled; });
    if (target) { target.scrollIntoView({ behavior: 'smooth', block: 'center' }); target.focus({ preventScroll: true }); }
  }
  cta.addEventListener('click', function () { if (!cta.classList.contains('disabled')) doBuy(); else chooseSize(); });
  if (stickyCta) stickyCta.addEventListener('click', function () {
    if (stickyCta.classList.contains('disabled')) { chooseSize(); return; }
    doBuy();
  });
  if (sockToggle) sockToggle.addEventListener('change', render);
  document.addEventListener('beneath:cart', render);
  document.addEventListener('beneath:socks', render);

  /* sticky bar visibility.
     On mobile the buy CTA sits far below the fold, so keep the bar on screen from the
     start — otherwise most visitors never see a price or a buy button at all.
     On desktop keep the original behaviour (show once the buy box scrolls away). */
  if (stickyBar) {
    var alwaysSticky = window.matchMedia && window.matchMedia('(max-width: 860px)').matches;
    if (alwaysSticky) {
      if (!allSoldOut()) { stickyBar.classList.add('visible'); stickyBar.removeAttribute('inert'); }
    } else if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var out = !entries[0].isIntersecting && !allSoldOut();
        stickyBar.classList.toggle('visible', out);
        if (out) stickyBar.removeAttribute('inert'); else stickyBar.setAttribute('inert', '');
      }, { threshold: 0 }).observe(box);
    }
  }

  /* ============ BACK-IN-STOCK CAPTURE ============ */
  var ntModal = document.querySelector('[data-notify-modal]');
  if (ntModal) {
    var ntTags = ntModal.querySelector('[data-notify-tags]');
    var ntSize = ntModal.querySelector('[data-notify-size]');
    var ntColor = ntModal.querySelector('[data-notify-color]');

    function ntSync() {
      if (!ntTags) return;
      var c = (ntColor && ntColor.value) || state.color || '';
      var s = (ntSize && ntSize.value) || state.size || '';
      var tags = ['notify'];
      if (c) tags.push('notify-' + c);
      if (c && s) tags.push('notify-' + c + '-' + s);
      ntTags.value = tags.join(',');
    }
    function ntToggle(open) {
      ntModal.classList.toggle('open', open);
      if (open) { ntModal.removeAttribute('inert'); } else { ntModal.setAttribute('inert', ''); }
      document.body.style.overflow = open ? 'hidden' : '';
    }
    function ntOpen() {
      // default to the colour on screen and the first sold-out size
      if (ntColor && state.color) ntColor.value = state.color;
      if (ntSize) {
        var out = Array.prototype.filter.call(sizeBtns, function (b) { return b.disabled; })[0];
        if (out) ntSize.value = out.dataset.size;
        else if (state.size) ntSize.value = state.size;
      }
      ntSync();
      ntToggle(true);
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-size-notify]')) { e.preventDefault(); ntOpen(); }
    });
    ntModal.addEventListener('click', function (e) {
      if (e.target.closest('[data-notify-close]') || e.target === ntModal) ntToggle(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && ntModal.classList.contains('open')) ntToggle(false);
    });
    if (ntSize) ntSize.addEventListener('change', ntSync);
    if (ntColor) ntColor.addEventListener('change', ntSync);
    // Shopify bounces back with ?customer_posted=true — reopen so they see the confirmation
    if (/[?&]customer_posted=true/.test(location.search)) ntToggle(true);
  }

  /* ============ SIZE FINDER ============ */
  var sizeModal = document.querySelector('[data-size-modal]');
  if (sizeModal) {
    var openers = document.querySelectorAll('[data-size-open]');
    openers.forEach(function (o) { o.addEventListener('click', function (e) { e.preventDefault(); sizeModal.classList.add('open'); sizeModal.removeAttribute('inert'); document.body.style.overflow = 'hidden'; }); });
    sizeModal.addEventListener('click', function (e) { if (e.target.closest('[data-size-close]') || e.target === sizeModal) { sizeModal.classList.remove('open'); sizeModal.setAttribute('inert', ''); document.body.style.overflow = ''; } });
    // [code, label, hLo, hHi, wLo, wHi]
    var SIZES = [
      ['m', 'M', 165, 178, 60, 78],
      ['l', 'L', 174, 186, 74, 92],
      ['xl', 'XL', 181, 193, 88, 106],
      ['xxl', 'XXL', 185, 200, 102, 125]
    ];
    var hEl = sizeModal.querySelector('[data-sg-height]');
    var wEl = sizeModal.querySelector('[data-sg-weight]');
    var resEl = sizeModal.querySelector('[data-sg-result]');
    var calc = sizeModal.querySelector('[data-sg-calc]');
    function recommend(h, w) {
      var mid = function (a, b) { return (a + b) / 2; };
      var dist = function (val, lo, hi) { return val < lo ? lo - val : (val > hi ? val - hi : 0); };
      var best = null;
      SIZES.forEach(function (s) {
        var score = 2 * (dist(w, s[4], s[5]) / 10) + dist(h, s[2], s[3]) / 6 + Math.abs(w - mid(s[4], s[5])) / 40;
        if (!best || score < best.score) best = { s: s, score: score };
      });
      return best ? best.s : null;
    }
    function runCalc() {
      var h = parseFloat(hEl.value), w = parseFloat(wEl.value);
      if (!Number.isFinite(h) || !Number.isFinite(w) || h < 140 || h > 210 || w < 40 || w > 160) { resEl.hidden = false; resEl.innerHTML = 'Enter a height of 140–210 cm and a weight of 40–160 kg.'; return; }
      var r = recommend(h, w);
      resEl.hidden = false;
      resEl.innerHTML = 'Suggested size: <b>' + r[1] + '</b><span class="sg-sub">Check your waist against the chart. Between sizes? Choose the larger size.</span>';
      // preselect it in the buy box if available
      var btn = box.querySelector('.size-opt[data-size="' + r[0] + '"]');
      if (btn && !btn.disabled) { btn.click(); }
    }
    if (calc) calc.addEventListener('click', runCalc);
    [hEl, wEl].forEach(function (el) { if (el) el.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); runCalc(); } }); });
  }

  renderGallery();
  refreshSizes();
  render();
})();
